import http from "../../helpers/http";

import {
  FETCH_FACTS_AND_STATS_CONTENT_SUCCESS,
  FETCH_FACTS_AND_STATS_CONTENT_FAILED
} from "../actions/actionTypes";

export const fetchData = () => (dispatch) => {
  http
    .get("facts-and-statistics")
    .then(({ data }) => {
      dispatch({
        type: FETCH_FACTS_AND_STATS_CONTENT_SUCCESS,
        payload: data
      });
    })
    .catch((error) => {
      dispatch({
        type: FETCH_FACTS_AND_STATS_CONTENT_FAILED,
        payload: error
      });
    });
};
